<template>
  <v-app>
    <v-app-bar app color="grey darken-4" dark dense>
      <v-hover v-slot:default="{ hover }" v-if="$store.getters.IsLoggedIn">
        <v-app-bar-nav-icon
          :color="hover ? 'primary' : 'white'"
          v-on:click="drawer = true"
        ></v-app-bar-nav-icon>
      </v-hover>
      <v-spacer></v-spacer>
      <v-icon left color="primary">mdi-solar-panel</v-icon>
      <v-toolbar-title v-on:click="navigateHome" class="noselect"
        >SolarOnTV</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn
        icon
        text
        class="hidden-sm-and-down"
        v-on:click="logout"
        v-if="$store.getters.IsLoggedIn"
      >
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary dark class="pa-0">
      <v-list class="pa-0" v-if="$store.getters.IsLoggedIn">
        <v-list-item>
          <v-list-item-avatar>
            <v-icon>mdi-face</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{
              this.$store.getters.UserName
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list dense shaped class="hidden-md-and-up">
        <v-subheader class="subtitle-2 font-weight-light ml-2">{{
          $t("Home.NavigationDrawer.User.Name")
        }}</v-subheader>
        <v-divider class="pa-0 mb-3"></v-divider>
        <v-list-item link v-on:click="logout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $t("Home.Toolbar.Logout")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list dense shaped v-for="category in categories" :key="category.name">
        <v-subheader class="subtitle-2 font-weight-light ml-2">{{
          category.name
        }}</v-subheader>
        <v-divider class="pa-0 mb-3"></v-divider>
        <drawer-item
          v-for="item in category.items"
          :key="item.title"
          :item="item"
        ></drawer-item>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <router-view
        v-on:show-error="showSnackError($event)"
        v-on:show-success="showSnackSuccess($event)"
      ></router-view>
    </v-content>

    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      right
      bottom
    >
      {{ snackbar.text }}
      <v-btn dark text v-on:click="snackbar.active = false">{{
        $t("Generic.Close")
      }}</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import DrawerItem from "@/components/App/DrawerItemComponent";

export default {
  name: "App",
  data() {
    return {
      colors: {
        success: "green",
        error: "red"
      },
      snackbar: {
        active: false,
        color: "",
        mode: "",
        timeout: 2500,
        text: ""
      },
      categories: [
        {
          name: this.$i18n.t("Home.NavigationDrawer.Common.Name"),
          items: [
            {
              title: this.$i18n.t("Home.NavigationDrawer.Common.Dashboard"),
              icon: "mdi-view-dashboard",
              link: "Home"
            },
            {
              title: this.$i18n.t("Home.NavigationDrawer.Common.DTAGenerator"),
              icon: "mdi-file-cog",
              link: "Generator"
            }
          ]
        },
        {
          name: this.$i18n.t("Home.NavigationDrawer.Admin.Name"),
          items: [
            {
              title: this.$i18n.t("Home.NavigationDrawer.Admin.Manage_Users"),
              icon: "mdi-account-multiple",
              link: "Users"
            },
            {
              title: this.$i18n.t("Home.NavigationDrawer.Admin.Manage_Sites"),
              icon: "mdi-domain",
              link: "Sites"
            },
            {
              title: this.$i18n.t(
                "Home.NavigationDrawer.Admin.Manage_Installers"
              ),
              icon: "mdi-solar-panel",
              link: "Installers"
            }
          ]
        }
      ],
      drawer: false
    };
  },
  methods: {
    navigateHome() {
      this.$router.push({
        name: this.$store.getters.IsLoggedIn ? "Home" : "Login"
      });
    },
    logout() {
      this.$store.dispatch("PostSuccessLogout");
    },
    showSnackError(toDisplay) {
      this.snackbar.color = this.colors.error;
      this.showSnack(toDisplay);
    },
    showSnackSuccess(toDisplay) {
      this.snackbar.color = this.colors.success;
      this.showSnack(toDisplay);
    },
    showSnack(toDisplay) {
      this.snackbar.active = true;
      this.snackbar.text = toDisplay;
    }
  },
  components: {
    DrawerItem
  }
};
</script>
<style scoped>
.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.noselect:hover {
  cursor: pointer;
}
</style>
